module.exports = __webpack_public_path__ + "img/txt.27fd2149.svg";